<template >
  <div
    class="formways-component formways-columns row"
    :class="ctx.customClass"
    :id="ctx.key"
  >
    <single-column
      v-for="(column, index) in ctx.columns"
      :key="index"
      :ctx-a="column"
      :store="store"
      :theme="theme"
    ></single-column>
  </div>
</template>

<script>
import singleColumn from './singleColumn.vue';
import SimpleComponentMixin from '../../mixins/SimpleComponentMixin';
import defaultSchema from './columnsDefaultSchema';

// TODO: Add a better key for v-for
export default {
  name: 'columns',
  components: {
    singleColumn
  },
  mixins: [SimpleComponentMixin],
  beforeCreate() {
    this.defaultSchema = defaultSchema;
  }
};
</script>
